import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from './Recharts.styled';

const SuccessTech: React.FC = () => {
  const GRAPH_08_SUCCESS_BY_TECH = [
    { label: 'C#', value: 100, fill: '#472ca6' },
    { label: 'Kubernetes', value: 100, fill: '#472ca6' },
    { label: '.NET', value: 94, fill: '#472ca6' },
    { label: 'Android', value: 85, fill: '#472ca6' },
    { label: 'Linux', value: 82, fill: '#472ca6' },
    { label: 'Vue.JS', value: 81, fill: '#472ca6' },
    { label: 'Angular', value: 80, fill: '#472ca6' },
    { label: 'PHP', value: 80, fill: '#472ca6' },
    { label: 'Kotlin', value: 78, fill: '#472ca6' },
    { label: 'Java', value: 77, fill: '#472ca6' },
    { label: 'Ruby', value: 77, fill: '#472ca6' },
    { label: 'React', value: 73, fill: '#472ca6' },
    { label: 'Docker', value: 70, fill: '#472ca6' },
    { label: 'iOS', value: 67, fill: '#472ca6' },
    { label: 'Node.js', value: 65, fill: '#472ca6' },
    { label: 'JS', value: 65, fill: '#472ca6' },
    { label: 'AWS', value: 64, fill: '#472ca6' },
    { label: 'Go', value: 63, fill: '#472ca6' },
    { label: 'Jenkins', value: 63, fill: '#472ca6' },
    { label: 'Python', value: 56, fill: '#472ca6' }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer width="99%" height={400}>
          <BarChart data={GRAPH_08_SUCCESS_BY_TECH}>
            <XAxis
              type="category"
              dataKey="label"
              tickLine={false}
              interval={0}
              angle={-90}
              textAnchor="end"
              height={80}
              dx={-5}
            />
            <YAxis
              type="number"
              allowDecimals={false}
              padding={{ bottom: 5 }}
              tickLine={false}
              width={40}
              tickFormatter={(tick: number) => {
                return tick + '%';
              }}
            />
            <Tooltip
              cursor={{ fill: '#e6dfff' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value + '%', '']}
              wrapperClassName="tooltip-x"
            />
            <Bar dataKey="value" fill="#472CA6" barSize={12} radius={6} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default SuccessTech;
